const targetElement = document.querySelector('header');
const className = 'scrolled';

function navInit() {
    function navClassUpdate() {
        if (window.scrollY > 0) {
            targetElement.classList.add(className);
        } else {
            targetElement.classList.remove(className);
        }
    }
    
    window.addEventListener('scroll', navClassUpdate);
    navClassUpdate();
    console.log('BEAUVOIR EDITS:', 'Nav initiated')
}

navInit();